import ItemSelector from './ItemSelector';

// 裁判项组件
function RefereeItem({ item, checked }) {
  return (
    <div className="flex items-center gap-3 min-w-0 flex-1">
      <div className="flex-shrink-0">
        <div
          className={`w-11 h-11 rounded-full flex items-center justify-center transition-colors ${
            checked ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-600'
          }`}
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path
              fillRule="evenodd"
              d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>

      <div className="min-w-0 flex-1">
        <div
          className={`text-sm font-medium truncate ${
            checked ? 'text-blue-700' : 'text-slate-800'
          }`}
        >
          {item.name}
        </div>
        <div
          className={`text-xs mt-0.5 truncate ${
            checked ? 'text-blue-600' : 'text-slate-500'
          }`}
        >
          {item.refereePhone || ''}
        </div>
      </div>
    </div>
  );
}

export default function RefereeSelector({
  open,
  onClose,
  onConfirm,
  name = '',
  selectedItems = [],
  onToggle = () => {},
  okText = '确定',
  api = '',
  multiple = true,
  addPath,
  onCreate,
}) {
  return (
    <ItemSelector
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      name={name}
      selectedItems={selectedItems}
      onToggle={onToggle}
      okText={okText}
      api={api}
      options={[{ value: 'name', label: '裁判姓名' }]}
      itemComponent={RefereeItem}
      multiple={multiple}
      addPath={addPath}
      onCreate={onCreate}
    />
  );
}
